import React from 'react';
import PropTypes from 'prop-types';

export class SoundCloud extends React.PureComponent {
	static propTypes = {
		url: PropTypes.string.isRequired,
	};

	state = {
		iframe: null,
	};

	// Can't use async => because of a Babel bug.
	constructor(props, context) {
		super(props, context);

		this.fetchSoundcloudWidget = this.fetchSoundcloudWidget.bind(this);
	}

	fetchSoundcloudWidget = async function(url) {
		this.setState({ iframe: null });

		try {
			const formData = new FormData();
			formData.append('format', 'json');
			formData.append('height', 91);
			formData.append('show_comments', false);
			formData.append('url', url);

			const result = await fetch('https://soundcloud.com/oembed', {
				body: formData,
				method: 'POST',
			}).then(response => response.json());

			if (result && result.html) {
				// They default to the Visual player which we don't want.
				const iframe = result.html
					.replace('visual=true&', '')
					.replace('height="400"', 'height="166"');

				this.setState({ iframe });
			}
		} catch (error) {
			this.setState({ error });
			console.error(error);
		}
	};

	componentWillReceiveProps = nextProps => {
		this.fetchSoundcloudWidget(nextProps.url);
	};

	componentDidMount = () => {
		this.fetchSoundcloudWidget(this.props.url);
	};

	render() {
		const { error, iframe } = this.state;

		if (error) {
			return <p>Error</p>;
		}
		if (!iframe) {
			return <p>Loading...</p>;
		}

		return (
			<div
				dangerouslySetInnerHTML={{
					__html: this.state.iframe,
				}}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/shared/soundCloud/component.js